import type { CityConfig } from "../city-template/types";

export const hollandConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Michigan DHHS Vital Records", href: "https://www.michigan.gov/mdhhs/adult-child-serv/informedconsent/vitalrecords", description: "Official Michigan vital records office in Lansing" },
    { label: "Marriage Licenses — Ottawa County Clerk", href: "https://www.miottawa.org/clerk", description: "Ottawa County Clerk — marriage license issuance" },
    { label: "Divorce Records — Ottawa County Clerk", href: "https://www.miottawa.org/clerk", description: "Ottawa County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Michigan DHHS for online vital record orders" },
  ],
  city: "Holland",
  state: "Michigan",
  stateAbbr: "MI",
  slug: "holland",
  route: "/holland",
  title: "Emergency Passport Holland, MI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Holland, Michigan — as fast as 24 hours. Fast passport renewal and new passport applications for Holland, Zeeland, Hudsonville, Saugatuck, and all Ottawa County residents. Lake Michigan shore and Tulip Time coverage. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Holland, MI",
  heroSubtitle: "Holland travelers — Ottawa County residents, Hope College students, Lake Michigan tourists, and international families — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Ottawa County and West Michigan.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20aerial%20view%20of%20Holland%20Michigan%20downtown%20with%20historic%20windmill%2C%20Big%20Red%20lighthouse%2C%20Lake%20Michigan%20shoreline%2C%20tulip%20gardens%2C%20lush%20green%20trees%2C%20warm%20golden%20hour%20light%2C%20clear%20blue%20sky%2C%20West%20Michigan%20coastal%20landscape%2C%20no%20text%20no%20people%2C%20cinematic%20landscape%20photography&width=1800&height=700&seq=holland-hero-001&orientation=landscape",
  heroImageAlt: "Holland Michigan downtown with Big Red lighthouse, windmill, and Lake Michigan shoreline at golden hour",
  geoPosition: "42.7875;-86.1089",
  geoPlacename: "Holland, Michigan",
  lastModified: "2026-06-02",
  regionalAgency: {
    name: "Detroit Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 180 miles east of Holland — appointments required, typically booked 2 weeks out",
  },
  nearbyCitiesZips: [
    { name: "Holland", zips: "49422, 49423, 49424" },
    { name: "Zeeland", zips: "49464" },
    { name: "Hudsonville", zips: "49426" },
    { name: "Saugatuck", zips: "49453" },
    { name: "Douglas", zips: "49406" },
    { name: "Fennville", zips: "49408" },
    { name: "Hamilton", zips: "49419" },
    { name: "Borculo", zips: "49464" },
    { name: "Jamestown", zips: "49427" },
    { name: "Grand Rapids", zips: "49501, 49503, 49504, 49505, 49506, 49507, 49508, 49509, 49512, 49525, 49534, 49544" },
    { name: "Wyoming", zips: "49509, 49519" },
    { name: "Jenison", zips: "49428" },
    { name: "Allendale", zips: "49401" },
    { name: "Grandville", zips: "49418" },
    { name: "Byron Center", zips: "49315" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to the Detroit Passport Agency — no appointment wait" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-global-line", title: "West Michigan Expertise", desc: "Lake Michigan shore, Gerald R. Ford International Airport, and Tulip Time travel passport support" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from anywhere in Ottawa County" },
  ],
  internalLinks: [
    { name: "Expedited passport in Grand Rapids, MI", route: "/grand-rapids" },
    { name: "Emergency passport services in Kalamazoo, MI", route: "/kalamazoo" },
    { name: "Urgent passport services in Muskegon, MI", route: "/muskegon" },
    { name: "Michigan passport services overview", route: "/michigan" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Holland, Michigan via secure registered courier and has direct access to the Detroit Passport Agency at 211 W. Fort St, Suite 1300. Our registered couriers hand-deliver your documents — meaning you get faster results without the 180-mile drive or appointment wait. Holland residents can ship from any UPS or FedEx in Ottawa County.",
  fpcOfficeDistance: "Serving Holland, Zeeland, Hudsonville, Saugatuck, Douglas, Fennville, Hamilton, and all of Ottawa County and West Michigan",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Holland and the greater Ottawa County region. From the Lake Michigan shoreline to the Tulip Time festival grounds, from Hope College campus to Saugatuck Dunes — we serve all of the West Michigan coast. The Detroit Passport Agency is approximately 180 miles east, and our couriers have direct access to it.",
  nearbyCitiesIntro: "We serve Holland and all Ottawa County communities including Zeeland, Hudsonville, Saugatuck, Douglas, Fennville, Hamilton, Borculo, Jamestown, and Jenison. We also serve West Michigan travelers and Gerald R. Ford International Airport flyers.",
  howItWorksIntro: "Most Holland travelers complete everything online and ship documents overnight. No driving 180 miles to the Detroit Passport Agency or waiting weeks for an appointment — our registered couriers handle the submission for you.",
  mistakesIntro: "Holland is a unique West Michigan community with heavy Lake Michigan tourism, Hope College international programs, and Tulip Time festival travel. Here are the most common passport mistakes we see from Ottawa County travelers.",
  testimonialsIntro: "Holland travelers — from Gerald R. Ford International Airport flyers to Lake Michigan beachgoers to Hope College students — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Holland, MI? Here are the most common ones we hear from Ottawa County and West Michigan travelers.",
  statePageRoute: "/states/michigan",
  statePageName: "Michigan",
  dmvWebsite: "https://www.michigan.gov/sos",
  dmvLabel: "Michigan SOS — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "No appointment wait — we handle submission", "Perfect for GRR Airport and West Michigan travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Direct access to Detroit Passport Agency", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Detroit Passport Agency (Self-Service)",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — typically 2 weeks out", "Life-or-death emergencies only", "Must appear in person in Detroit — 180-mile drive", "Full day commitment — parking + wait time"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Holland travelers with immediate departure needs — as fast as 24 hours. Our couriers go directly to the Detroit Passport Agency. Perfect for last-minute Gerald R. Ford International Airport flights, family emergencies, and Lake Michigan cruise travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier to Detroit Passport Agency", "GRR Airport and West Michigan travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Holland adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Ottawa County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Holland residents and families — including Hope College students, new citizens, and Ottawa County families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Holland residents who lost their passport before international travel or GRR Airport departure.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Holland-area families planning international vacations, Saugatuck Dunes trips, or visiting family abroad.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Holland and Ottawa County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Holland MI", description: "Urgent passport processing for Holland Michigan travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Holland MI", description: "Fast passport renewal for Holland Michigan residents with a previously-issued passport." },
    { name: "First-Time Passport Holland MI", description: "New passport application services for Holland Michigan residents applying for their first passport." },
    { name: "Child Passport Holland MI", description: "Minor passport services for Holland Michigan families with children under 16." },
  ],
  testimonials: [
    {
      name: "Jennifer L.",
      location: "Holland, MI",
      rating: 5,
      text: "Flying to Amsterdam for Tulip Time sister city exchange in 4 days and my passport was expired. Fast Passport Center saved the trip — renewed in 3 days. I shipped from the UPS Store on 8th Street and had it back before I even packed.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Robert K.",
      location: "Zeeland, MI",
      rating: 5,
      text: "Hope College study abroad to Spain in 6 days and my daughter's passport was lost. Fast Passport Center had a replacement in our hands in 48 hours. No driving to Detroit, no appointment wait. Their courier service is a lifesaver for Ottawa County.",
      service: "Lost Passport Replacement",
    },
    {
      name: "Amanda T.",
      location: "Saugatuck, MI",
      rating: 5,
      text: "Lake Michigan cruise to the Caribbean with 8 days notice. Fast Passport Center processed my passport in 4 days. They caught a mistake on my application that would have delayed me.",
      service: "First-Time Passport",
    },
    {
      name: "David M.",
      location: "Holland, MI",
      rating: 5,
      text: "Business trip to London and I realized my passport was expiring too soon. Fast Passport Center got me a renewed passport in 2 days. I shipped from the FedEx in Holland and everything was seamless.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "hol-1",
      name: "Detroit Passport Agency",
      type: "Regional Passport Agency",
      address: "230 S Dearborn St, Suite 380",
      city: "Detroit",
      state: "MI",
      zip: "48226",
      phone: "(313) 226-7110",
      hours: "Mon–Fri: 8:00 AM – 3:00 PM (by appointment only)",
      distance: "Approximately 180 miles east of Holland — appointments typically booked 2 weeks out",
      website: "https://travel.state.gov/content/travel/en/passports/get-fast/passport-agencies.html",
      websiteLabel: "Schedule Appointment",
      notes: "Michigan's only regional passport agency. Serves travelers with international travel within 14 days (or 28 days with visa). Appointments are required — no walk-ins. Fast Passport Center couriers have direct access and can skip the appointment backlog.",
      icon: "ri-government-line",
    },
    {
      id: "hol-2",
      name: "Holland Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: " 61 E. 8th St",
      city: "Holland",
      state: "MI",
      zip: "49423",
      phone: "(616) 396-2301",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Holland — near the historic district",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Holland acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to downtown Holland and Hope College area residents.",
      icon: "ri-mail-line",
    },
    {
      id: "hol-3",
      name: "Zeeland Post Office",
      type: "USPS Passport Acceptance Facility",
      address: " 150 E. Main Ave",
      city: "Zeeland",
      state: "MI",
      zip: "49464",
      phone: "(616) 772-2114",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Zeeland — approximately 8 miles east of Holland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Zeeland and eastern Ottawa County residents. Call to confirm current passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "hol-4",
      name: "Grand Rapids Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: " 600 Fountain St",
      city: "Grand Rapids",
      state: "MI",
      zip: "49503",
      phone: "(616) 458-3351",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Grand Rapids — approximately 30 miles northeast of Holland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Grand Rapids and northern Ottawa County residents. Larger facility with more appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "hol-5",
      name: "Hudsonville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: " 3460 Chicago Dr",
      city: "Hudsonville",
      state: "MI",
      zip: "49426",
      phone: "(616) 669-2821",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Hudsonville — approximately 15 miles northeast of Holland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Hudsonville and northern Ottawa County residents. Book early during summer travel season.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — typically 2 weeks out", fpc: "No — we handle the Detroit agency submission" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "In-Person Requirement", agency: "Yes — must appear at 211 W. Fort St", fpc: "No — ship from anywhere in Ottawa County" },
    { feature: "GRR Airport & West Michigan Expertise", agency: "No tailored advice", fpc: "Yes — Gerald R. Ford International Airport and West Michigan travel" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Holland and Ottawa County travelers often discover passport issues right before Tulip Time trips or GRR Airport departure. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-passport-line",
      title: "Using a Passport Card for International Air Travel",
      description: "Some Holland-area travelers assume a passport card is sufficient for all travel — but passport cards are only valid for land and sea border crossings. All international flights require a passport book.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo shops sometimes produce photos that meet ID requirements but not passport standards. Photos must be exactly 2x2 inches with a plain white or off-white background, taken within 6 months.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form for New Passports",
      description: "Missing signatures or incorrect form completion are the #1 rejection reasons at Ottawa County acceptance facilities. Our document review catches these before submission.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Gerald R. Ford International Airport Flight Requirements",
      description: "Gerald R. Ford International Airport (GRR) in Grand Rapids has growing international flight options. Many Holland travelers also use Chicago O'Hare. Verify passport requirements for all connecting airports.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming the Detroit Agency Has Walk-In Slots",
      description: "The Detroit Passport Agency requires appointments and is typically booked 2 weeks out. There are no same-day walk-in slots — plan ahead or use Fast Passport Center's courier service.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Ottawa County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Holland, Zeeland, or Grand Rapids." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Detroit Passport Agency — no 180-mile drive or appointment wait required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Ottawa County address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Where is the nearest passport agency to Holland, MI?", a: "The Detroit Passport Agency is the nearest regional passport agency to Holland, located at 230 S Dearborn St, Suite 380, Chicago, IL 60604 — approximately 180 miles east. It is open Monday through Friday 8:00 AM – 3:00 PM by appointment only. Appointments are typically booked 2 weeks out. Fast Passport Center's registered couriers have direct access and can submit applications without individual appointments, saving you the long drive and wait." },
    { q: "How fast can I get an emergency passport in Holland?", a: "Fast Passport Center offers emergency passport processing in Holland, Michigan in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Detroit Passport Agency — without you needing to drive 180 miles east or take a day off work." },
    { q: "Do I need a passport for international flights from Gerald R. Ford International Airport?", a: "Yes. All international flights from Gerald R. Ford International Airport (GRR) in Grand Rapids require a passport book. GRR serves Holland and all of West Michigan. While GRR has growing international options, many Holland travelers also connect through Chicago O'Hare or Detroit Metro for international flights. A passport book is required for all international air travel regardless of your departure airport." },
    { q: "Can I get an expedited passport in the Holland suburbs like Zeeland or Saugatuck?", a: "Absolutely. Fast Passport Center serves all of Ottawa County including Zeeland, Saugatuck, Douglas, Fennville, Hudsonville, and all surrounding communities. Our courier service works the same way everywhere — complete online, ship documents, we handle the rest." },
    { q: "What airports do Holland-area travelers use for international flights?", a: "Gerald R. Ford International Airport (GRR) in Grand Rapids is the primary airport for Holland and West Michigan — approximately 30 miles northeast. GRR has growing domestic and international service. Detroit Metro Wayne County Airport (DTW) in Romulus is the primary international hub — approximately 180 miles east. Many Holland travelers also use Chicago O'Hare (ORD) for international connections. Always verify your passport is valid for at least 6 months past your return date." },
    { q: "How much does an expedited passport cost in Holland, MI?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Can Holland-area residents get passport photos taken locally?", a: "Yes. Walgreens and CVS locations throughout Holland, Zeeland, and Grand Rapids offer passport photos. UPS Stores, FedEx Office locations, and many AAA offices also provide passport photos. Photos must be 2x2 inches on a white or off-white background, taken within the last 6 months." },
    { q: "Does Fast Passport Center serve the Upper Peninsula from Holland?", a: "Yes. Fast Passport Center serves all of Michigan including the Upper Peninsula. Our courier service is especially valuable for remote UP communities, which would otherwise face an 8+ hour drive to the Detroit Passport Agency. We serve Marquette, Sault Ste. Marie, Houghton, Escanaba, and all UP communities — you just ship your documents overnight and we handle everything from there." },
  ],
  photoLocations: [
    { name: "Walgreens — Holland", address: "3035 W. Shore Dr, Holland, MI 49424", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Holland", address: " 947 W. 8th St, Holland, MI 49423", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/" },
    { name: "UPS Store — Holland", address: " 12330 James St, Holland, MI 49424", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "Walgreens — Grand Rapids", address: " 2025 E. Beltline Ave, Grand Rapids, MI 49525", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
  ],
  dmvLocations: [
    { name: "Michigan SOS — Holland", address: " 12330 James St, Holland, MI 49424", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Michigan Secretary of State office for driver's licenses, REAL ID, and vehicle registration. Serves Holland, Zeeland, and central Ottawa County. Reserve a spot online to avoid wait times.", featured: true },
    { name: "Michigan SOS — Grand Rapids", address: " 3777 3 Mile Rd, Grand Rapids, MI 49544", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Serves Grand Rapids, Wyoming, and northern Ottawa County communities. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "GRR",
      name: "Gerald R. Ford International Airport",
      distance: "Located in Grand Rapids — approximately 30 miles northeast of Holland",
      address: "5500 44th St SE, Grand Rapids, MI 49512",
      note: "Primary airport for Holland and West Michigan. Growing domestic and international service. Southwest, Delta, American, United, and Allegiant service. International flights to Cancun and Toronto available seasonally. Most Holland international travelers connect through DTW or Chicago O'Hare.",
      flightUrl: "https://www.grr.org/",
      flightLabel: "GRR Airport Info",
      featured: false,
    },
    {
      code: "DTW",
      name: "Detroit Metro Wayne County Airport",
      distance: "Approximately 180 miles east of Holland via I-96",
      address: "1 Detroit Metro Airport, Romulus, MI 48242",
      note: "Primary international hub for West Michigan. Delta Air Lines hub. Direct flights to London, Amsterdam, Tokyo, Paris, Mexico City, Cancun, and 40+ international destinations. Largest airport in Michigan. Most Holland international travelers connect through DTW.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "DTW Flight Info",
      featured: true,
    },
  ],
};